import {
  Box,
  Text,
  Textarea,
  VStack,
  Button,
  HStack,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalOverlay,
  useDisclosure,
  Tooltip,
} from "@chakra-ui/react";
import FileUpload1 from "./FileUpload";
import { useEffect, useState } from "react";
import { getPromptFramework } from "../../../allApi/api";
import SchedularWorkFlow from "../schedular/SchedularWorkFlow";
import { MdSchedule } from "react-icons/md";

const AutomationPrompt = ({
  setformDataAutomation,
  formDataAutomation,
  files,
  setFiles,
  // scheduleFormData,
  // setscheduleFormData,
}) => {
  const [loader, setLoader] = useState(false);
  const {
    isOpen: isopenSchedular,
    onOpen: onOpenSchedular,
    onClose: onCloseSchedular,
  } = useDisclosure();
  const promptFetchHandle = async () => {
    try {
      setLoader(true);
      const resData = await getPromptFramework();
      setformDataAutomation((prev) => ({
        ...prev,
        query: resData,
      }));
      // setformDataAutomation(resData);
    } catch (error) {
      throw new Error("Automation Api fetching " + error);
    } finally {
      setLoader(false);
    }
  };

  const handlechange = (e) => {
    const { name, value } = e.target;
    setformDataAutomation((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  useEffect(() => {
    promptFetchHandle();
  }, []);

  return (
    <>
      <Box
        h="70vh"
        bg="white"
        p={0}
        borderRadius="lg"
        w={{ base: "100%", md: "100%" }}
      >
        <Text fontSize="xl" fontWeight="bold">
          Automation Prompt
        </Text>
        <Text fontSize="sm" color="gray.600" mb={1}>
          Upload your files and business automation prompts to get results
          tailored to your needs.
        </Text>

        <Box
          h="20%"
          border="1px solid"
          borderColor="gray.300"
          borderRadius="md"
          display="flex"
          alignItems="center"
          justifyContent="center"
          cursor="pointer"
        >
          <FileUpload1
            setFormData={setformDataAutomation}
            formData={formDataAutomation}
            files={files}
            setFiles={setFiles}
          />
        </Box>

        <VStack align="start" spacing={3} mt={4} h="65%">
          <HStack justifyContent={"space-between"} w="100%">
            <Text fontSize="sm" fontWeight="bold">
              Text Prompt
            </Text>
            <Tooltip label="Schedule Workflow" aria-label="Open Scheduler ">
              <Button onClick={onOpenSchedular}>
                <MdSchedule />
              </Button>
            </Tooltip>
          </HStack>
          {loader ? (
            <Text>Loading..</Text>
          ) : (
            <Textarea
              name="query"
              value={formDataAutomation?.query}
              h="100%"
              placeholder="Text content of the message on behalf of the AI-coworker"
              onChange={handlechange}
            />
          )}
        </VStack>
      </Box>
      <Modal
        isOpen={isopenSchedular}
        onClose={onCloseSchedular}
        isCentered
        blockScrollOnMount={false}
        closeOnOverlayClick={false}
      >
        <ModalOverlay />
        <ModalContent w={"auto"} maxW="auto" h={"auto"}>
          <ModalCloseButton />
          <ModalBody>
            <SchedularWorkFlow
              formData={formDataAutomation}
              setFormData={setformDataAutomation}
              onCloseSchedular={onCloseSchedular}
            />
          </ModalBody>

          <ModalFooter>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  );
};

export default AutomationPrompt;
